import React, { useState, useEffect, useContext} from 'react';
import Card from '../../../components/card.component';
import {
  Col,
  Row,
} from 'react-bootstrap';
import table from '../reportes.table';
import DataTable from 'react-data-table-component';
import sucursalFunction from '../../sucursales/sucursal.functions';
import moment from 'moment';
import notification from '../../../components/notification.component';
import reportesFunctions from '../reportes.functions';
//import PrinterDiario from '../imprimir/diario.printer';
import utils from '../../../utils/utils.functions';
import { DateRangePicker } from 'rsuite';
import UsuariosSelect from '../../../components/usuarios.component';
import { ConfigContextUtils } from '../../../context/contextUtils.context';
import pad from 'pad';
import { ConfigContext } from '../../../context/config.context';
import numeral from 'numeral';


const DesgloseBolReport = () => {

  const { config } = useContext(ConfigContext);
  const { setPreloader } = useContext(ConfigContextUtils);
  const rpValuesOne = {
    fecha_inicio:  moment(new Date()).format('YYYY-MM-DD'),
    fecha_fin:  moment(new Date()).format('YYYY-MM-DD'),
    usuario_id: null,
    cliente_id: null,
    sucursal_id: [],
  }

  const initCalendar = [new Date(), new Date()];

  const [sucursales, setSucursales] = useState([]);
  const [reporteOne, setRerporteOne] = useState(rpValuesOne);
  const [dataRpOne, setDataRpOne] = useState([]);
  const [toggleOne, setToggleOne] = useState(false);
  const [pagos, setPagosCalculate] = useState({
    puntoVentas: 0,
    efectivo: 0,
    transferencia: 0,
  });

  const [total, setTotal] = useState(0);
  const [dataOriginal, setOriginalValue] = useState(initCalendar);

  useEffect(() => {
    listarSucursales();
  },[]);

  useEffect(() => {
    let totalSum = (pagos.puntoVentas + pagos.efectivo + pagos.transferencia);
    setTotal(totalSum);
  },[pagos]);


  useEffect(() => {
        if (dataRpOne.length) {

          let puntoVenta = 0;
          let efectivo = 0;
          let transferencia = 0;

          dataRpOne.forEach((x) => {
            if (x.estado) {
              x.boleta_pago.forEach(e => {
                if (e.boleta_pagos_tipo.description === 'Punto de venta') {
                  puntoVenta += parseInt(e.monto);
                } else if (e.boleta_pagos_tipo.description === 'Transferencia') {
                  transferencia += parseInt(e.monto);
                } else if (e.boleta_pagos_tipo.description === 'Efectivo') {
                  efectivo += parseInt(e.monto);
                }
              })
            }
          });

          setPagosCalculate({
            puntoVentas: puntoVenta,
            efectivo: efectivo,
            transferencia: transferencia,
          });
        }
  },[dataRpOne]);


  const selection = (row) => {
    setRerporteOne({
      ...reporteOne,
      sucursal_id: row.id,
    })
  }

  const resetDate = () => {
    setRerporteOne(rpValuesOne);
    setOriginalValue(initCalendar);
    resetReportOne();
  }

  const resetReportOne = () => {
    setRerporteOne(rpValuesOne);
    setToggleOne(!toggleOne);
    setDataRpOne([]);
    setOriginalValue(initCalendar);
  }

  const listarSucursales = () => {
    sucursalFunction.listado().then((response) => {
      setSucursales(response.data);
    })
  }

  const setValueRpOne = (value) => {
    setRerporteOne({
      ...reporteOne,
      fecha_inicio: moment(value[0]).format('YYYY-MM-DD'),
      fecha_fin: moment(value[1]).format('YYYY-MM-DD'),
    });

    setOriginalValue(value);
  }

  const generarReporteOne = () => {
    if (reporteOne.fecha_inicio && reporteOne.fecha_fin) {

      const payload = {
       ...reporteOne,
      }


      if (!payload.sucursal_id || !payload.sucursal_id.length) {
        notification.warning('Debe seleccionar al menos una sucursal');
        return false;
      }

      setPreloader(true);
 
      reportesFunctions.diariobol(payload).then((response) => {
        setDataRpOne(response.data);
        setPreloader(false);
      })
    } else {
      notification.warning('Debe seleccionar al menos una sucursal y rango de fechas');
    }
  }


  const formatDate = (dateValue) => {
      const parts = dateValue.split('T');
      const rtDate = moment(parts[0]).format('DD/MM/YYYY');
      return rtDate;
  }

  const colummns = [
    {
      name: 'Registrado',
      selector: 'createdAt',
      sortable: true,
      width: '10%',
      wrap: true,
      cell: row => {
      return formatDate(row.createdAt);
      }
    },
    {
       name: 'Recibo',
       selector: 'id',
       sortable: true,
       cell: row => (
         pad(5, row.id, '0')
       )
     },
     {
      name: 'Tipo venta',
      selector: 'guia_id',
      sortable: true,
      cell: row => {
        if (row.type_document !== 'VN') {
          return row.type_document === 'ND' ? 'NOTA DE DEBITO' : 'NOTA DE CRÉDITO2';
        } else {
          return row.guia_id ? `GUIA ${row.boleta_guia.prefijo_guia || config.prefijo_correlativo_guia}-${row.boleta_guia.guia_paquete}` : `VENTA PRODUCTOS`;
        }
      }
     },
     {
      name: 'Monto pago',
      selector: 'monto_total',
      sortable: true,
      cell: row => {

        return row.guia_pendiente ? '--' : <div style={{ color: !row.estado ? 'red' : 'black' }}>{utils.formatMoney(!row.estado ? -1 * row.monto_total : row.monto_total, 0)}</div>
      }
     },
     {
      name: 'Gestor',
      selector: row => row.boleta_gestor.username,
      sortable: true,
     },
     {
      name: 'Sucursal',
      selector: row => row.boleta_sucursal.description.toUpperCase(),
      sortable: true,
     },
     {
      name: 'Estado',
      selector: 'estado',
      sortable: true,
      cell: row => {
        return row.estado ? <span className="badge badge-success">PAGADO</span> : <span className="badge badge-danger">ANULADO</span>
      }
     },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: '72px', // override the row height
      }
    },
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '8px',
      },
    },
  };

  const generateStringPayment = (itemPagos) => {
      let formatString = '';

      itemPagos.forEach((item, index) => {
        formatString += `${index > 0 ? ', ' : ''}${item.boleta_pagos_tipo.description} (${item.referencia !== "" ? item.referencia : ''})`
      });

      return formatString;
  }


  const calculatePesoPies = (itemBultos) => {

      let calculate = { peso: 0, pies: 0 };
      let peso = 0;
      let pies = 0;

      if (itemBultos) {
         itemBultos.bultos.forEach((item) => {
            peso = peso + item.peso;
            pies = pies + item.pie;
         });

         calculate = { peso: numeral(peso).format('0.00'), pies: numeral(pies).format('0.00') };
      }

      return calculate;

  }

  const parsedataexcelformat = () => {

    const dates = {
      fecha_inicio: moment(reporteOne.fecha_inicio).format('DD/MM/YYYY'),
      fecha_fin: moment(reporteOne.fecha_fin).format('DD/MM/YYYY'),
    }


    const parsedata = dataRpOne.map((item) => {
        return {
            id: item.id,
            usuario: item.boleta_gestor.username,
            cliente: item.boleta_cliente.name.toUpperCase(),
            rut: item.boleta_cliente.rut,
            fecha: formatDate(item.fecha),
            hora: item.hora ,
            monto_total: item.monto_total,
            sucursal: item.boleta_sucursal.description,
            estado: item.estado,
            tipo_venta: item.boleta_guia ? `GUIA ${item.boleta_guia.prefijo_guia}-${item.boleta_guia.guia_paquete}` : 'VENTA PRODUCTOS',
            forma_pago: generateStringPayment(item.boleta_pago),
            ...(calculatePesoPies(item.boleta_guia)),
            guia_master: item.boleta_guia ? item.boleta_guia.master_guia.description : 'N/A',
            tipo_envio: item.boleta_guia ? item.boleta_guia.master_guia.rel_tipos.description : 'N/A',
            observacion: item.observacion,
        }
    });

    const payload = {
      data: parsedata,
      ...dates,
      sucursal: 'Todas',
      pagos: {
        efectivo: pagos.efectivo,
        punto: pagos.puntoVentas,
        transferencia: pagos.transferencia,
      }
    }

    reportesFunctions.excelSoldReportV2(payload);
  }

  const userselectedfilter = (value) => {
    setRerporteOne({
      ...reporteOne,
      usuario_id: value.id !== 'null' ? value.id : null,
    });
  }

  const valuesPayments = () => {
    return <Row>
      <Col className="d-flex justify-content-between">
          <div>
              <small>Efectivo</small>
              <div className="monto-text">{utils.formatMoney(pagos.efectivo)}</div>
          </div>
          <div>
              <small>Punto de venta</small>
              <div className="monto-text">{utils.formatMoney(pagos.puntoVentas)}</div>
          </div>
          <div>
              <small>Transferencias</small>
              <div className="monto-text">{utils.formatMoney(pagos.transferencia)}</div>
          </div>
          <div>
              <small>Total ventas</small>
              <div className="monto-text amount-good">{utils.formatMoney(total)}</div>
          </div>
        </Col>
      <Col></Col>
    </Row>
  }

  const sucursalSelected = (rows) => {
    const sucursalIds = rows.selectedRows.map(item => item.id);
    setRerporteOne({
      ...reporteOne,
      sucursal_id: sucursalIds,
    });
  }

  return (
    <>
    <Row className="mt-3">
      <Col>
        <Card>
        <div className="d-flex flex-row">
          <div className="d-flex w-50">
            <div className="d-flex flex-column grupo-input mr-2 w-100">
              <small>Día de calculo</small>
              <DateRangePicker
                format={'DD/MM/YYYY'}
                value={dataOriginal}
                onClean={resetDate}
                onChange={value => {
                  setValueRpOne(value);
                }}
                block
                locale={utils.configCalendar.locale}
              /> 
            </div>
          </div>
          <div className="d-flex w-50">
            <div className="d-flex flex-column grupo-input mr-2 w-100">
              <small>Filtrar por usuario</small>
              <UsuariosSelect
                onSelected={(value) => userselectedfilter(value)}
                reset={null}
              />
            </div>
          </div>
          </div>
          <DataTable
            title="Sucursales"
            customStyles={table.customStyles}
            columns={table.columnSucursalesOption(selection, reporteOne.sucursal_id)}
            data={sucursales}
            dense={true}
            pagination={true}
            paginationPerPage={5}
            selectableRows={true}
            onSelectedRowsChange={sucursalSelected}
            clearSelectedRows={toggleOne}
            contextMessage={{
              singular: 'Sucursal',
              plural: 'Sucursales',
              message: 'seleccionados',
            }}
          />
          <div className="mt-2 d-flex">
           <button onClick={generarReporteOne} type="button" className="btnx btnx-warn">Generar</button> {' '}
           <button onClick={resetReportOne} type="button" className="btnx btnx-warn">Limpiar</button> {' '}
          </div>
        </Card>
      </Col>
    </Row>

    {dataRpOne && 
    <Row className="mt-3">
      <Col>
      { dataRpOne.length ?
        <Card>
              <div className="d-flex justify-content-between mb-2">
                <div className="d-flex flex-column">
                  <div style={{ fontWeight: 'bold' }}>Rango de fechas consultados desde {moment(reporteOne.fecha_inicio).format('DD/MM/YYYY')} hasta {moment(reporteOne.fecha_fin).format('DD/MM/YYYY')}</div>
                  <div style={{ fontWeight: 'bold' }}>Total de registros: {dataRpOne.length}</div>
                </div>
                <div className="d-flex">
                  <div className="d-flex flex-row" style={{ height: 44 }}>
                    {/*<PrinterDiario config={config} data={dataRpOne} suc={reporteOne.sucursales.length}/>*/ }
                    <button onClick={parsedataexcelformat} type="button" className="btnx btnx-warn ml-1">Exportar excel</button>
                  </div>
                </div>
              </div>
              { dataRpOne.length && valuesPayments() }
        
            <div className="mt-2">
              <DataTable
                noHeader={true}
                customStyles={customStyles}
                columns={colummns}
                data={dataRpOne}
                dense={true}
                pagination={true}
                paginationPerPage={40}
                noDataComponent={'No se encontraron registros'}
              />
            </div>
        </Card>
            : null
          }
      </Col>
    </Row>
    }
    </>
  )
}

export default DesgloseBolReport;